import { Form } from '@douyinfe/semi-ui';

export const TitleFormItem = () => (
  <Form.TextArea
    maxLength={40}
    maxCount={40}
    rules={[
      {
        required: true,
        message: '请填写标题',
      },
    ]}
    rows={1}
    autosize={true}
    className="w-[560px] "
    placeholder={'请填写标题'}
    field={'Title'}
    label={'标题'}
  />
);
